import React, { useState } from 'react';
import {
  Box,
  Dialog,
  IconButton,
  Tooltip,
  makeStyles,
} from '@material-ui/core';
import { XIcon } from './adsAgentIcons';
import { AD } from './adsAgentTokens';
import { ProductImage } from './adsGenerator.types';

// Port of whatsapp-console-frontend `src/pages/AdTemplates/ProductUploadStrip.js`.
const THUMB = 64;
const THUMB_PAD = 5;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 14,
    padding: '18px 14px 2px',
  },
  thumb: {
    position: 'relative',
    width: THUMB,
    height: THUMB,
    padding: THUMB_PAD,
    boxSizing: 'border-box',
    borderRadius: AD.radiusLg,
    flexShrink: 0,
    background: AD.surface,
    border: `1px solid ${AD.border}`,
    boxShadow: AD.shadowCard,
    cursor: 'zoom-in',
    '&:hover $remove': { opacity: 1 },
  },
  imageWrap: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: AD.radius,
    overflow: 'hidden',
    background: AD.surfaceSunken,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  remove: {
    position: 'absolute',
    top: -9,
    right: -9,
    width: 22,
    height: 22,
    padding: 0,
    opacity: 0,
    background: AD.surface,
    border: `1px solid ${AD.border}`,
    boxShadow: AD.shadowCard,
    color: AD.text,
    transition: 'opacity 120ms ease',
    '&:hover': { background: AD.surface },
    '&:focus': { opacity: 1 },
    '@media (hover: none)': { opacity: 1 },
  },
  preview: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '80vh',
  },
}));

const ProductUploadStrip = (props: Props): React.ReactElement | null => {
  const { items, onRemove } = props;
  const classes = useStyles();
  const [preview, setPreview] = useState('');

  if (!items.length) {
    return null;
  }

  return (
    <>
      <Box className={classes.root}>
        {items.map((item) => (
          <Box
            key={item.id}
            className={classes.thumb}
            onClick={() => setPreview(item.previewUrl)}
          >
            <Box className={classes.imageWrap}>
              <img
                className={classes.image}
                src={item.previewUrl}
                alt={item.name || 'Product'}
              />
            </Box>
            <Tooltip title="Remove">
              <IconButton
                className={classes.remove}
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  onRemove(item.id);
                }}
                aria-label={`Remove ${item.name || 'image'}`}
              >
                <XIcon size={13} />
              </IconButton>
            </Tooltip>
          </Box>
        ))}
      </Box>

      <Dialog
        open={Boolean(preview)}
        onClose={() => setPreview('')}
        maxWidth="md"
        aria-label="Product image"
      >
        {preview ? (
          <img className={classes.preview} src={preview} alt="Product" />
        ) : null}
      </Dialog>
    </>
  );
};

interface Props {
  items: ProductImage[];
  onRemove: (id: string) => void;
}

export default ProductUploadStrip;
